module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO ORIGINAL X-767a93993d8a4f624f916f615a7b0835.png";